import { useEffect, useState } from 'react';
import '../assets/css/userStatistics.css';
import Sidebar from '../components/Sidebar';
import api from '../api/client';

// ── Composant cercle de progression ──────────────────────────────
function ProgressCircle({ percentage = 0 }) {
    const deg = (percentage / 100) * 360;
    return (
        <div style={{
            width: 90, height: 90, borderRadius: '50%',
            background: `conic-gradient(#EB6424 ${deg}deg, #eee 0deg)`,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            flexShrink: 0,
        }}>
            <div style={{
                width: 66, height: 66, borderRadius: '50%',
                background: 'white',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                fontWeight: 800, fontSize: '1rem', color: '#EB6424'
            }}>
                {percentage}%
            </div>
        </div>
    );
}

// ── Composant nombre de jeux terminés ────────────────────────────
function GamesDone({ count = 0, total = 0 }) {
    return (
        <div className="stat-card games-done" style={{ padding: '24px' }}>
            <div className="title">
                <h4>NOMBRE DE JEUX TERMINÉS</h4>
            </div>
            <div style={{ textAlign: 'center', margin: '16px 0' }}>
                <span style={{ fontSize: '3rem', fontWeight: 800, color: '#EB6424' }}>
                    {count}
                </span>
                <p style={{ fontSize: '0.85rem', color: '#888', marginTop: 4 }}>
                    ce mois-ci · {total} au total
                </p>
            </div>
        </div>
    );
}

// ── Composant calendrier (série en cours) ────────────────────────
function Calendar({ streak = 0 }) {
    return (
        <div className="stat-card calendar" style={{ padding: '24px' }}>
            <div className="title">
                <h4>SÉRIE EN COURS</h4>
            </div>
            <div style={{ textAlign: 'center', margin: '16px 0' }}>
                <span style={{ fontSize: '3rem', fontWeight: 800, color: '#EB6424' }}>
                    {streak}
                </span>
                <p style={{ fontSize: '0.85rem', color: '#888', marginTop: 4 }}>
                    jour{streak > 1 ? 's' : ''} consécutif{streak > 1 ? 's' : ''}
                </p>
            </div>
        </div>
    );
}

// ── Page Stats ────────────────────────────────────────────────────
export default function Stats() {
    const [stats, setStats] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        api.get('/api/gameplay/stats/')
            .then(({ data }) => {
                setStats(data);
                setLoading(false);
            })
            .catch((err) => {
                setError(err.message);
                setLoading(false);
            });
    }, []);

    return (
        <div className="page-container">
            <Sidebar />

            <div className="content-container" id="userStats">
                <div className="statistics-container">

                    {loading ? (
                        <div className="loading-container"><h1>Chargement...</h1></div>
                    ) : error ? (
                        <div className="error-container"><h2>Erreur lors du chargement des statistiques.</h2></div>
                    ) : (
                        <div className="content">

                            <GamesDone count={stats.games_this_month} total={stats.total_games} />

                            <div className="theme-revised stat-card">
                                <div className="title">
                                    <h4>Thème le plus révisé</h4>
                                    <span>{stats.top_theme ? stats.top_theme.toUpperCase() : '—'}</span>
                                </div>
                                {stats.favorite_game && (
                                    <p style={{ fontSize: '0.85rem', color: '#888', marginTop: 8, padding: '0 16px 16px' }}>
                                        Jeu favori : {stats.favorite_game}
                                    </p>
                                )}
                            </div>

                            {/* <div className="empty stat-card"></div> */}

                            <Calendar streak={stats.streak_days} />

                            <div className="stat-datas stat-card">
                                <div className="good-answers-test">
                                    <ProgressCircle percentage={stats.pct_correct} />
                                    <div className="text">
                                        <p>de bonnes réponses</p>
                                        <p className="specific">ce mois-ci</p>
                                    </div>
                                </div>
                                <div className="speed">
                                    <ProgressCircle percentage={stats.pct_correct_prev} />
                                    <div className="text">
                                        <p>de bonnes réponses</p>
                                        <p className="specific">le mois dernier</p>
                                    </div>
                                </div>
                                <div className="good-answers-month">
                                    <ProgressCircle percentage={Math.max(0, stats.pct_correct - stats.pct_correct_prev)} />
                                    <div className="text">
                                        <p>de progression</p>
                                        <p className="specific">par rapport au mois dernier</p>
                                    </div>
                                </div>
                            </div>

                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}